<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ImpairmentTable from "./components/impairment-table.vue";
import { isNil } from "lodash";

/**
 * @typedef RubricaImpairment
 * @property {number | undefined} id
 * @property {string} rubrica
 * @property {string} tipo_rubrica
 * @property {number} rubrica_id
 * @property {object} competencias
 * @property {Object.<string, number>} competencias
 */

export default {
  components: { ImpairmentTable },
  data() {
    return {
      acumulados: [],
      calculos: [],
      competencias: [],
      endMonth: ""
    };
  },
  computed: {
    ...mapGetters(["clientId", "user"]),
    actionBarButtons() {
      return [
        {
          text: "Atualizar",
          icon: "mdi-refresh",
          action: async () => {
            this.doLoad();
          }
        }
      ];
    },
    impairmentId() {
      return this.$route.params.id;
    }
  },
  created() {
    this.doLoad();
  },
  methods: {
    async doLoad() {
      const toCurrencyValue = this.$options.filters.toCurrencyValue;

      try {
        const resource = this.apiResource(
          `v1/ativacaoped/${this.clientId}/impairments`
        );
        const response = await resource.get(this.impairmentId);
        const {
          calculos_vpl,
          data_inicio_iniciativa,
          data_fim_iniciativa,
          diferenca_orcado_revisado,
          rxo,
          vida_util
        } = response.data;
        this.endMonth = moment(data_fim_iniciativa, "YYYY-MM").format(
          "YYYY-MM"
        );
        const projectStart = moment(data_inicio_iniciativa, "YYYY-MM");
        const projectEnd = moment(data_fim_iniciativa, "YYYY-MM").add(
          vida_util,
          "years"
        );
        const size = projectEnd.diff(projectStart, "months") + 1;
        this.competencias = Array.from({ length: size }, (_, index) => {
          return moment(projectStart)
            .add(index, "months")
            .format("YYYY-MM");
        });

        if (isNil(calculos_vpl)) {
          throw new Error("Nenhum teste de impairment encontrado.");
        }

        this.calculos = [
          {
            id: calculos_vpl.projetado.business_plan_id,
            type: "projetado",
            label: `${calculos_vpl.projetado.business_plan_nome} (${calculos_vpl.projetado.business_plan_versao_label})`,
            rows: calculos_vpl.projetado.rubricas
          },
          {
            id: calculos_vpl.realizado.business_plan_id,
            type: "realizado",
            label: `${calculos_vpl.realizado.business_plan_nome} (${calculos_vpl.realizado.business_plan_versao_label})`,
            rows: calculos_vpl.realizado.rubricas
          }
        ];

        this.acumulados = [
          {
            label: "Diferença ORÇADO (BP) x REVISÃO",
            value: "R$ " + toCurrencyValue(diferenca_orcado_revisado)
          },
          {
            label: "RxO",
            value: "R$ " + toCurrencyValue(rxo)
          }
        ];
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }

        this.competencias = [];
        this.calculos = [];
        this.acumulados = [
          {
            label: "Diferença ORÇADO (BP) x REVISÃO",
            value: "R$ 0,00"
          },
          {
            label: "RxO",
            value: "R$ 0,00"
          }
        ];

        return;
      }
    }
  }
};
</script>

<template>
  <v-card :color="tableColor" elevation="0">
    <v-card-text class="d-flex">
      <div
        v-for="(button, idx) in actionBarButtons"
        class="table-v-action-button mr-2"
        :key="'action-bar-' + idx"
        @click="button.action"
      >
        <v-icon>{{ button.icon }}</v-icon>
        {{ button.text }}
      </div>
    </v-card-text>

    <ImpairmentTable
      class="impairment-table"
      :calculos="calculos"
      :acumulados="acumulados"
      :competencias="competencias"
      :endMonth="endMonth"
    ></ImpairmentTable>
  </v-card>
</template>

<style lang="scss" scoped>
.v-card {
  height: calc(100% - 1rem);
  display: flex;
  flex-direction: column;
  overflow: auto;

  .v-card__text {
    flex-shrink: 0;
  }
}

.impairment-table::v-deep.v-data-table {
  border-radius: 0;
  width: 100%;
}
</style>
